import React from 'react';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import { get } from 'lodash';
import { connect } from 'react-redux';

class IntlProviderHOC extends React.Component {
  constructor (props) {
    super(props);
    // This is to account for the components that use its own locale like locale of space or booking
  }

  render () {
    // This is to account for the components that use its own locale like locale of space or booking
    const preferredLocale = get(this.props, 'profile.data.preferred_locale', '');

    return (
      <SharedIntlProviderHOC
        {...this.props}
        locale={preferredLocale}
        preferredLocale={preferredLocale}
      />
    );
  }
}

export default IntlProviderHOC;
